import React from "react";
import { FaTasks } from "react-icons/fa";

const Success = () => {
  return (
    <div className="blog" style={{ backgroundColor: "#453364" }}>
      <div
        className="grid grid-cols-1 py-10  "
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="stats ">
          <div className="stat">
            <div className="stat-figure  " style={{ color: "#453364" }}>
             
            </div>
            <div className="stat-value  " style={{ color: "#453364" }}>
              2,378+
            </div>
            <div className="text-[18px] font-bold" style={{ color: "#453364" }}>
              Successful recovery stories
            </div>
            
            {/* <div className="stat-desc text-1xl font-bold">
              21% more than last month
            </div> */}
          </div>
          <div className="stat">
            <div className="stat-figure  " style={{ color: "#453364" }}>
             
            </div>
            <div className="stat-value  " style={{ color: "#453364" }}>
              2000+
            </div>
            <div className="text-[18px] font-bold" style={{ color: "#453364" }}>
            HealthCare related man power in our platform
            </div>
            
            {/* <div className="stat-desc text-1xl font-bold">
              21% more than last month
            </div> */}
          </div>

         

          {/* <div className="stat">
            <div className="stat-figure  " style={{ color: "#453364" }}>
           
            </div>
            <div
              className="stat-value "
              style={{ color: "#453364" }}
            >
              500+
            </div>
            <div className="text-[18px] font-bold" style={{ color: "#453364" }}>
              HealthCare related man power in our platform
            </div>
            
           
          </div> */}
        
          <div className="stat">
            <div className="stat-figure  " style={{ color: "#453364" }}>
             
            </div>
            <div className="stat-value  " style={{ color: "#453364" }}>
              3000+
            </div>
            <div className="text-[18px] font-bold" style={{ color: "#453364" }}>
              Medical assistant
            </div>
            
          
          </div>
          <div className="stat">
            <div className="stat-figure  " style={{ color: "#453364" }}>
             
            </div>
            <div className="stat-value  " style={{ color: "#453364" }}>
              150+
            </div>
            <div className="text-[18px] font-bold" style={{ color: "#453364" }}>
              Physiotherapists
            </div>
            
          
          </div>
          <div className="stat">
            <div className="stat-figure  " style={{ color: "#453364" }}>
             
            </div>
            <div className="stat-value  " style={{ color: "#453364" }}>
              200+
            </div>
            <div className="text-[18px] font-bold" style={{ color: "#453364" }}>
Nurses
            </div>
            
          
          </div>
          <div className="stat">
            <div className="stat-figure  " style={{ color: "#453364" }}>
             
            </div>
            <div className="stat-value  " style={{ color: "#453364" }}>
              250+
            </div>
            <div className="text-[18px] font-bold" style={{ color: "#453364" }}>
              Caregivers
            </div>
            
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
